import {createSlice} from '@reduxjs/toolkit'
import {saveAction, setLoaderAction, defaultInitState} from "./reducerDefaults";


export const collectionSlice = createSlice({
    name: 'collection',
    initialState: defaultInitState,
    reducers: {
        saveCollection: saveAction,
        setCollectionLoader: setLoaderAction
    },
})

export const {saveCollection, setCollectionLoader} = collectionSlice.actions
export default collectionSlice.reducer
